module.exports = __webpack_public_path__ + "static/haven-831677ac414b877057b2ce31e48335a5.jpg";